import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";
import { rememberFormContact } from "../lib/cookieConsent";
import useContactPrefill from "../lib/useContactPrefill";

function Footer() {
  const { seed, filled } = useContactPrefill();
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  // Seed the fields once we know what (if anything) to pre-fill. Re-runs if the
  // visitor accepts cookies after the footer has already rendered.
  useEffect(() => {
    setForm({ name: seed.name, email: seed.email, phone: seed.phone });
  }, [seed]);

  const update = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }));
    setSent(false);
    setError("");
  };

  const openCookiePreferences = () => {
    if (typeof window !== "undefined" && window.openCookiePreferences) {
      window.openCookiePreferences();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      setError("Please enter your name and email.");
      return;
    }
    // Remember contact details for next time — a safe no-op unless the visitor
    // accepted the "Simplified Forms" cookie category.
    rememberFormContact({
      name: form.name,
      email: form.email,
      phone: form.phone,
    });
    setError("");
    setSent(true);
  };

  return (
    <footer className="footer">
      <h2 className="follow">Follow us on</h2>
      <div className="social-icons">
        <a
          href="https://www.facebook.com/alfasouthincafe"
          target="_blank"
          rel="noopener noreferrer"
          className="icon facebook"
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a
          href="https://www.instagram.com/alfasouthincafe/"
          target="_blank"
          rel="noopener noreferrer"
          className="icon instagram"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a
          href="https://x.com/alfasouthincafe"
          target="_blank"
          rel="noopener noreferrer"
          className="icon x"
        >
          <FontAwesomeIcon icon={faXTwitter} />
        </a>
      </div>
      <form className="footer-form" onSubmit={handleSubmit}>
        <h3 className="footer-form-title">Get in Touch</h3>
        {filled && (
          <p className="footer-form-welcome">
            Welcome back — we've filled in your details.
          </p>
        )}
        <div className="footer-form-row">
          <input
            type="text"
            className="footer-input"
            placeholder="Name"
            value={form.name}
            onChange={update("name")}
          />
          <input
            type="email"
            className="footer-input"
            placeholder="Email"
            value={form.email}
            onChange={update("email")}
          />
          <input
            type="tel"
            className="footer-input"
            placeholder="Phone"
            value={form.phone}
            onChange={update("phone")}
          />
          <button type="submit" className="footer-submit-btn">
            Send
          </button>
        </div>
        {error && <p className="footer-form-error">{error}</p>}
        {sent && (
          <p className="footer-form-success">
            Thanks! We've received your details.
          </p>
        )}
      </form>
      <nav className="footer-links">
        <Link to="/privacy-policy" className="footer-link">
          Privacy Policy
        </Link>
        <Link to="/cookie-policy" className="footer-link">
          Cookie Policy
        </Link>
        <button
          type="button"
          className="footer-cookie-link"
          onClick={openCookiePreferences}
        >
          Cookie Settings
        </button>
      </nav>
      <p className="footer-text">
        © 2025 Alfa Southin Cafe. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
